import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { baseQueryWithProviderCountry } from "@/redux/baseQuery";

export const vehicleApi = createApi({
  baseQuery: baseQueryWithProviderCountry("vehicle"),
  reducerPath: "vehicleApi",
  endpoints: () => ({}),
});
